// src/components/PreviewImportModal.jsx
import React from "react";

const Rows = React.memo(function Rows({ items, limit = 10000 }) {
  return items.slice(0, limit).map((it, idx) => (
    <tr key={idx}>
      <td>{it.referenceNo}</td>
      <td>{it.productDescription}</td>
      <td>{it.warehouse}</td>
      <td>{it.quantity}</td>
      <td>{it.unit}</td>
      <td>{it.price}</td>
      <td>{it.discount}</td>
      <td>{it.netPrice}</td>
      <td>{it.amount}</td>
    </tr>
  ));
});

export default function PreviewImportModal({
  items = [],
  uploadFilename = "",
  drHeader = {},
  onCancel,
  onConfirm,
  tableMaxHeight = 600,
  tableMaxWidth = 600,
}) {
  const {
    drNo = "",
    drDate = "",
    drType = "",
    docType = "",
    remarks = "",
  } = drHeader || {};

  return (
    <div className="p-3">
      <h5 className="fw-bold mb-2">Preview Import ({items.length} rows)</h5>
      {uploadFilename ? (
        <p className="text-muted mb-3">{uploadFilename}</p>
      ) : null}

      {/* DR header block */}
      <div className="mb-3">
        <p className="mb-1">
          <strong>DR No#:</strong> {drNo}
        </p>
        <p className="mb-1">
          <strong>Date:</strong> {drDate}
        </p>
        <p className="mb-1">
          <strong>DR Type:</strong> {drType}
        </p>
        <p className="mb-1">
          <strong>Document Type:</strong> {docType}
        </p>
        <p className="mb-1">
          <strong>Remarks:</strong> {remarks}
        </p>
      </div>

      <div
        className="table-responsive"
        style={{
          maxHeight: tableMaxHeight,
          maxWidth: tableMaxWidth,
          overflow: "auto",
        }}
      >
        <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Reference No</th>
              <th>Description</th>
              <th>Whse</th>
              <th>Qty</th>
              <th>Unit</th>
              <th>Price</th>
              <th>Disc</th>
              <th>Net</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <Rows items={items} />
          </tbody>
        </table>
      </div>

      <div className="d-flex gap-2 mt-3">
        <button className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button
          className="btn text-white"
          style={{ background: "#82c14a" }}
          onClick={onConfirm}
        >
          Import All {items.length}
        </button>
      </div>
    </div>
  );
}
